import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  rightSideContainer = new BehaviorSubject<TemplateRef<any> | null>(null);
}
